export default __webpack_public_path__ + "static/media/BorderKingdomsCimmerianEnd.91ba5ba5.jpg";